import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS } from "@/data/content";
import { Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-32 border-t border-white/5 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-12">
        <div className="overline mb-10">Build a better connection between design and production</div>
        <h2 className="font-serif text-[10vw] md:text-[7vw] leading-[0.92] tracking-tighter text-[#EAEAEA] mb-12">
          Let&apos;s review<br />
          <span className="text-[#B58B5D] italic">your project.</span>
        </h2>

        <div className="grid md:grid-cols-12 gap-10 pt-12 border-t border-white/5">
          <div className="md:col-span-5">
            <Link to="/" className="inline-block">
              <img
                src="/logo/designlayer-full-white.png"
                alt="Designlayer"
                className="h-28 md:h-32 w-auto"
              />
            </Link>
            <p className="mt-6 text-[15px] text-[#A3A3A3] max-w-md leading-relaxed">
              {BRAND.footerCopy}
            </p>
            <div className="mt-8 space-y-3">
              <a data-testid="footer-email" href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-[#EAEAEA] hover:text-[#B58B5D] transition-colors">
                <Mail size={16} className="text-[#B58B5D]" />
                <span className="text-sm">{BRAND.email}</span>
              </a>
              <div className="flex items-center gap-3 text-[#A3A3A3]">
                <MapPin size={16} className="text-[#B58B5D]" />
                <span className="text-sm">Remote worldwide</span>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Sitemap</div>
            <ul className="space-y-3">
              {NAV_LINKS.slice(0, 6).map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-[#A3A3A3] hover:text-[#EAEAEA] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline mb-5">More</div>
            <ul className="space-y-3">
              {NAV_LINKS.slice(6).map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-[#A3A3A3] hover:text-[#EAEAEA] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/legal" className="text-sm text-[#A3A3A3] hover:text-[#EAEAEA] transition-colors">
                  Privacy / Terms
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline mb-5">Studio</div>
            <p className="text-sm text-[#A3A3A3] leading-relaxed">
              Interior design.<br />
              Architectural visualization.<br />
              Cabinetry production systems.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#5c5c5c]">
            © {new Date().getFullYear()} Designlayer. All rights reserved.
          </p>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#5c5c5c]">
            Design. Visualize. Engineer. Manufacture.
          </p>
        </div>
      </div>
    </footer>
  );
}
